export default [
  {
    icon: 'star',
    size: 16,
    color: '#005ed9',
    position: { top: '15px', left: '-22px' },
    animationDuration: '2.4s',
    animationDelay: '0.5s',
  },
  {
    icon: 'point',
    size: 4,
    color: '#E7004F',
    position: { bottom: '15px', left: '18px' },
    animationDuration: '2.2s',
    animationDelay: '0.2s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#1f9bbf',
    position: { top: '-13px', left: '20%' },
    animationDuration: '2.1s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#005ed9',
    position: { top: '0px', right: '18%' },
    animationDuration: '2.5s',
    animationDelay: '0.7s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#005ed9',
    position: { top: '60px', right: '-22px' },
    animationDuration: '3s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#005ed9',
    position: { bottom: '-10px', right: '20px' },
    animationDuration: '2.1s',
    animationDelay: '0.3s',
  },
  {
    icon: 'point',
    size: 4,
    color: '#E7004F',
    position: { top: '23%', right: '8px' },
    animationDuration: '2.6s',
    animationDelay: '1s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#1f9bbf',
    position: { top: '12px', right: '27px' },
    animationDuration: '2.8s',
    animationDelay: '0.1s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#1f9bbf',
    position: { top: '10px', right: '30%' },
    animationDuration: '2.3s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#1f9bbf',
    position: { bottom: '10px', right: '22%' },
    animationDuration: '2.3s',
    animationDelay: '0.8s',
  },
  {
    icon: 'point',
    size: 4,
    color: '#E7004F',
    position: { bottom: '-8px', right: '20%' },
    animationDuration: '2.6s',
    animationDelay: '0.5s',
  },
  {
    icon: 'star',
    size: 16,
    color: '#1f9bbf',
    position: { top: '-15px', right: '12%' },
    animationDuration: '2.1s',
    animationDelay: '0.5s',
  },
].map((props, key) => ({ ...props, key }));
